import { Component, OnDestroy, Output, EventEmitter } from "@angular/core";
import { ModalService } from "@services/modal.service";

@Component({
  selector: "app-modal-operations-confirm",
  templateUrl: "./modal-operations-confirm.component.html",
  styleUrls: ["./modal-operations-confirm.component.scss"],
})
export class ModalOperationsConfirmComponent implements OnDestroy {
  @Output() confirm: EventEmitter<object> = new EventEmitter();

  titleValue: string = "";

  constructor(public modal: ModalService) { }

  ngOnDestroy() {
    this.modal.close();
  }

  accept() {
    const titleValue = this.titleValue;
    this.modal.close();
    this.confirm.emit({ titleValue });
    this.titleValue = "";
  }

  requiresUpdatingValueTitle(): boolean {
    const payload = this.modal && this.modal.payload;

    if (!payload) {
      return false;
    }

    const isDigital =
      payload.origin && payload.origin.toLowerCase().indexOf("digital") !== -1;
      
    const isThreePayments =
      payload.productType &&
      payload.productType.toLowerCase().indexOf("trespg") !== -1;

    return payload.type === "nonPayment" && isDigital && !isThreePayments;
  }

  isConfirmDisabled(): boolean {
    if (this.requiresUpdatingValueTitle()) {
      return !this.titleValue || !this.titleValue.trim();
    }

    return false;
  }
}
